import { useParams } from 'react-router-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import CategoryApi from '../../../lib/api/category/CategoryApi';
import useToastMsg from '../../common/useToastMsg';
import { CATEGORY } from '../../../constants/queryKeys';
import categoryToastMsg from '../../../constants/service/toastMsg/categoryToastMsg';

/**
 * 카테고리 정보를 수정하는 mutation hook
 * @param setIsEditable
 * @return {{editCategory: UseMutationResult<unknown, unknown, void, unknown>}}
 */
const useCategoryEdit = () => {
  const { id } = useParams();
  const { success } = useToastMsg();

  const queryClient = useQueryClient();

  const editCategory = useMutation({
    mutationFn: (data) => CategoryApi.editCategory(id, data),
    onSuccess: async () => {
      const result = await CategoryApi.getCategoryDetail(id);

      // 업데이트 된 상세고리 상세 데이터를 쿼리 데이터로 설정
      queryClient.setQueryData([...CATEGORY.DETAIL, id], result);
      // 수정 이력 캐싱데이터 초기화
      queryClient.invalidateQueries([...CATEGORY.HISTORY_LIST, id]);

      success(categoryToastMsg.EDIT_CATEGORY_REQUEST_SUCCESS);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { editCategory };
};

export default useCategoryEdit;
